export default "__VITE_ASSET__CfBQI96M__"